/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component,Input } from '@angular/core';

import {TimeModel } from '../time.model';
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'du-display-time',
  templateUrl: './display-time.component.html',
  styleUrls: ['./display-time.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class DisplayTimeComponent {

  @Input() time: TimeModel | null | undefined = null;

}
